import React from 'react'
import itemTypes from '../../../config/itemTypes'
import getTrueProps from '../../../helpers/getTrueProps'
import { Input, Label, FormGroup, } from 'reactstrap'

export default function SelectItemType(props) {
  const validItemTypes = getTrueProps(itemTypes)
  const options = validItemTypes.map((itemType, n) => {
    return <option key={`itemTypeOption${n}`} value={itemType}>{itemType}</option>
  })
  
  return (
    <FormGroup>
      <Label htmlFor='itemType'>Item Type</Label>
      <Input
        type='select'
        name='itemType'
        id='itemType'
        disabled={!props.active}
        value={props.activeItemType}
        onChange={(e) => props.handleChangeItemType(e)}
      >
        {props.active ? options : <option></option>}
      </Input>
    </FormGroup>
  )
}

/*
      <FormGroup>
        <Label htmlFor='nodeTags'>Add a Node Tag</Label>
        <Input
          type='select'
          name='nodeTags'
          id='nodeTags'
          onChange={(e) => this.handleChange(e)}
          value={this.state.selectedOption}
        >


*/


// WEBPACK FOOTER //
// ./src/components/Content/CreateManageContent/SelectItemType.js